import React from "react";
import { useEffect } from "react";
import { Table, Form, Modal, Button, Row, Col } from "react-bootstrap";
import ExportApi from "../api/ExportApi";
import { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import PendingSingleTable from "./PendingSingleTable";
import FilterModal from "./FilterModal";
import OutsideClickHandler from "react-outside-click-handler";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthUser } from "../customHooks/useAuthUser";
import { logo_image } from "../helper/constant";

const PendingTable = () => {
  const loggedInUser = useAuthUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL
  const [logineduser, setLogineduser] = useState(null);
  const [Data, setData] = useState();
  const [Data2, setData2] = useState();
  const [show, setShow] = useState();
  const [userId, setUserId] = useState();
  const [sellerName, setSellerName] = useState();
  const [sellerAddress, setSellerAddress] = useState();
  const [sellerPhone, setSellerPhone] = useState();
  const [sellerZipCode, setSellerZipCode] = useState();
  const [sellerState, setSellerState] = useState();
  const [sellerCity, setSellerCity] = useState();
  const [orderId, setOrderId] = useState(null);
  const [shipeByDate , setShipByDate] = useState(null);
  const [buyerName, setBuyerName] = useState("Gpuwiz");
  const [order , setOrder] = useState(null);

  const [buyerAddress, setBuyerAddress] = useState(
    "CHANDLER J GILBERT 2089 BAKER ST  LONDON W1U 6RN  ENGLAND"
  );
  const [buyerPhone, setBuyerPhone] = useState();
  const [buyerZipCode, setBuyerZipCode] = useState("99999");
  const [buyerCity, setBuyerCity] = useState("Hougang");

  const [selectData, setSelectData] = useState();
  const [buyerState, setBuyerState] = useState();
  const [orderCreateDate, setOrderCreateDate] = useState();
  const [buyerBid, setBuyerBid] = useState();
  const [buyerSalesTax, setBuyerSalesTax] = useState();
  const [buyerSubTotal, setBuyerSubTotal] = useState();
  const [buyerProductName, setBuyerProductName] = useState();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [buyerSku, setBuyerSku] = useState();
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [currentSortOrder, setCurrentSortOrder] = useState(1);
  const [res, setres] = useState();
  const [buyerProductCondition, setBuyerProductCondition] = useState();
  const [descriptionindex, setdescriptionindex] = useState();
  const [productId, setProductId] = useState();
  const [productStatus, setProductStatus] = useState();
  const [showBuyerData, setShowBuyerData] = useState(true);
  const [buyOrder, setBuyOrder] = useState([]);
  const [sellerOrder, setSellerOrder] = useState([]);
  const dataToDisplay = showBuyerData ? Data2 : Data;
  const dataToDisplayText = showBuyerData ? "Data2" : "Data";
  const [position, setPosition] = useState({ top: 0, left: 55 });
  const [positionShipping, setPositionShipping] = useState({ top: 59, left: 137 });
  const [loading, setLoading] = useState(false);
  const orderData = showBuyerData ? buyOrder : sellerOrder

  const [filteredListData, setFilteredListData] = useState([]);
  const [filterList, setFilterList] = useState();
  const [selectStatusFilter, setSelectStatusFilter] = useState([])
  const [filteredBuyOrder, setFilteredBuyOrder] = useState(buyOrder);

  const [nbrand, setNbrand] = useState();
  const [nseries, setNseries] = useState();
 const [nmodel, setNmodel] = useState();
 const [norderid, setNorderid] = useState();
 const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [sellercount, setSellerCount] = useState(0);
  const [buyercount, setBuyerCount] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  useEffect(() => {
    if (searchParams.has("seller-data")) {
      setShowBuyerData(false);

      searchParams.delete("seller-data");
      navigate(
        { search: searchParams.toString() },
        { replace: true }
      );
    } else {
      setShowBuyerData(true);
    }
  }, []);

  const [filteredSellerOrder, setFilteredSellerOrder] = useState(sellerOrder);
  const [selectedFilters, setSelectedFilters] = useState({
    condition: [],
    chipset: [],
    brands: [],
    series: [],
    model: [],
  });
 
  const statusOptions = [
    'Waiting on Seller',
    'Pending Inspection',
    'Ready to Ship',
    'Shipped Out',
  ];
  const token = localStorage.getItem("tokenuser");
  const [showFilterModel, setShowFilterModel] = useState(false);


  //  Sorting Table Data
  const getNestedProperty = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  
  const sortHere = (key) => {
 
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
  
    const sortedProducts = [...Data2].sort((a, b) => {
      const aValue = getNestedProperty(a, key);
      const bValue = getNestedProperty(b, key);
  
      if (aValue < bValue) return -1 * sortOrder;
      if (aValue > bValue) return 1 * sortOrder;
      return 0;
    });
    const sortedProduct1 = [...Data].sort((a, b) => {
      const aValue = getNestedProperty(a, key);
      const bValue = getNestedProperty(b, key);
  
      if (aValue < bValue) return -1 * sortOrder;
      if (aValue > bValue) return 1 * sortOrder;
      return 0;
    });
  
   
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
    setData2(sortedProducts);
    setData(sortedProduct1);
  };
  

  // const handleShippingModal = (selectedOrderId) => {
  //   console.log(selectedOrderId,"selectData>>>!23");
  //   setButtonLoader(true);
  //   if (selectedOrderId) {
  //     setShow(true);
  //     handleshippingData(selectedOrderId);
  //   } else {
  //     toast.error("Please Select Product First");
  //   }
  // };
  const handleShippingModal = () => {
    setButtonLoader(true);
    if (orderId) {
      setShow(true);
      handleshippingData();
    } else {
      toast.error("Please Select Product First");
    }
  };


  const [alreadyCreatedShippingLabel, setAlreadyCreatedShippingLabel] = useState();

  // const handleshippingData = (selectedOrderId) => {
  //   console.log(selectedOrderId,"selectedOrderId>>>")
  //   setButtonLoader(true);
  //   ExportApi.getShippingData(selectedOrderId)
  //     .then((resp) => {
  //       let data = resp.data.Data;
    
      
  //       setSellerName(data.sellerId.firstname);
  //       setSellerAddress(data.sellerId.shipping_address.street);
  //       setSellerCity(data.sellerId.shipping_address.city);
  //       setSellerState(data.sellerId.shipping_address.state);
  //       setSellerZipCode(data.sellerId.shipping_address.postal_code);
  //       setSellerPhone(data.sellerId.phone);
  //       setBuyerBid(data?.bidId?.bidAmount);
  //       setBuyerSalesTax(data?.bidId?.salesTax);
  //       setBuyerSubTotal(data?.bidId?.subTotal);
  //       setBuyerProductName(data.productId.productname);
  //       setButtonLoader(false);
  //       setBuyerSku(data?.productId?.sku);
  //       setNorderid(data?.orderId);
  //       setBuyerProductCondition(data?.productId?.type);
  //       setNbrand(data?.productId?.brand);
  //       setNseries(data?.productId?.series);
  //       setNmodel(data?.productId?.model);
       
  //       // setBuyerCondition(data?.productId)

  //       setBuyerAddress(resp?.data?.adminAddress?.shipping_address?.street);
  //       setBuyerCity(resp?.data?.adminAddress?.shipping_address?.city);
  //       setBuyerState(resp?.data?.adminAddress?.shipping_address?.state);
  //       setBuyerZipCode(resp?.data?.adminAddress?.shipping_address?.postal_code);
  //       // setOrderCreateDate(resp?.data?.adminAddress?.shipping_address?.createdAt);
  //       setAlreadyCreatedShippingLabel(data?.deliveryStatusId?.sellerShippingLabel);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // ,"Pending Inspection","Shipped Out"
 
 
  // const handleshippingData = () => {
  //   setButtonLoader(true);
  //   ExportApi.getShippingData(orderId)
  //     .then((resp) => {
  //       let data = resp.data.Data;
    
      
  //       setSellerName(data.sellerId.firstname);
  //       setSellerAddress(data.sellerId.shipping_address.street);
  //       setSellerCity(data.sellerId.shipping_address.city);
  //       setSellerState(data.sellerId.shipping_address.state);
  //       setSellerZipCode(data.sellerId.shipping_address.postal_code);
  //       setSellerPhone(data.sellerId.phone);
  //       setBuyerBid(data?.bidId?.bidAmount);
  //       setBuyerSalesTax(data?.bidId?.salesTax);
  //       setBuyerSubTotal(data?.bidId?.subTotal);
  //       setBuyerProductName(data.productId.productname);
  //       setButtonLoader(false);
  //       setBuyerSku(data?.productId?.sku);
  //       setNorderid(data?.orderId);
  //       setBuyerProductCondition(data?.productId?.type);
  //       setNbrand(data?.productId?.brand);
  //       setNseries(data?.productId?.series);
  //       setNmodel(data?.productId?.model);
       
  //       // setBuyerCondition(data?.productId)

  //       setBuyerAddress(resp?.data?.adminAddress?.shipping_address?.street);
  //       setBuyerCity(resp?.data?.adminAddress?.shipping_address?.city);
  //       setBuyerState(resp?.data?.adminAddress?.shipping_address?.state);
  //       setBuyerZipCode(resp?.data?.adminAddress?.shipping_address?.postal_code);
  //       // setOrderCreateDate(resp?.data?.adminAddress?.shipping_address?.createdAt);
  //       setAlreadyCreatedShippingLabel(data?.deliveryStatusId?.sellerShippingLabel);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };


  const handleshippingData = () => {
    setButtonLoader(true);
    ExportApi.getShippingData(orderId)
      .then((resp) => {
        let data = resp.data.Data;
      
        setSellerName(data.sellerId.firstname);
        setSellerAddress(data.sellerId.shipping_address.street);
        setSellerCity(data.sellerId.shipping_address.city);
        setSellerState(data.sellerId.shipping_address.state);
        setSellerZipCode(data.sellerId.shipping_address.postal_code);
        setSellerPhone(data.sellerId.phone);
        setBuyerBid(data?.bidId?.bidAmount);
        setBuyerSalesTax(data?.bidId?.salesTax);
        setBuyerSubTotal(data?.bidId?.subTotal);
        setBuyerProductName(data.productId.productname);
        setButtonLoader(false);
        setBuyerSku(data?.productId?.sku);
        setNorderid(data?.orderId);
        setBuyerProductCondition(data?.productId?.type);
        setNbrand(data?.productId?.brand);
        setNseries(data?.productId?.series);
        setNmodel(data?.productId?.model);
       
        // setBuyerCondition(data?.productId)
        const fullname =  resp?.data?.adminAddress?.firstname + resp?.data?.adminAddress?.lastname 
        setBuyerName(fullname||" Gpuwiz");
        setBuyerAddress(resp?.data?.adminAddress?.shipping_address?.street);
        setBuyerPhone(resp?.data?.adminAddress?.phone);
        setBuyerCity(resp?.data?.adminAddress?.shipping_address?.city);
        setBuyerState(resp?.data?.adminAddress?.shipping_address?.state);
        setBuyerZipCode(resp?.data?.adminAddress?.shipping_address?.postal_code);
        // setOrderCreateDate(resp?.data?.adminAddress?.shipping_address?.createdAt);
        setAlreadyCreatedShippingLabel(data?.deliveryStatusId?.sellerShippingLabel);
      })
      .catch((err) => {
        console.log(err);
      });
  };










  // const handleShippingLabel = () => {
  //   setButtonLoader(true);
  //   if (alreadyCreatedShippingLabel == null) {
  //     ExportApi.updateShippingLabelData(
  //       userId,
  //       orderId,
  //       "Shipped From Seller",
  //       "Pending Inspection",
  //       "Shipped Out"
  //     )
  //       .then((resp) => {
  //         if (resp.data.message == "Label created") {
  //           toast.success("Shipped From Seller Successfully");
  //           DownloadPdf();
  //           setButtonLoader(false);
  //           handleClose();
  //           // window.open(resp.data.Data.postage_label.label_url, "_blank");
            
  //           if (localStorage.getItem("tokenuser")) {
  //             handlePendingData(JSON.parse(localStorage.getItem("tokenuser")).id);
  //             setButtonLoader(false);
  //           } else if (localStorage.getItem("admin")) {
  //             handlePendingData(JSON.parse(localStorage.getItem("admin")).id);
  //             setButtonLoader(false);
  //           } else {
           
  //             setButtonLoader(false);
  //           }
  //         } else {
  //           toast.error(resp.data.message);
  //           handleClose();
  //           setButtonLoader(false);
  //           if (localStorage.getItem("tokenuser")) {
  //             handlePendingData(JSON.parse(localStorage.getItem("tokenuser")).id);
  //           } else if (localStorage.getItem("admin")) {
  //             handlePendingData(JSON.parse(localStorage.getItem("admin")).id);
  //           } else {
  //             console.log("No Data Found");
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         setButtonLoader(false);
  //       });
  //   } else {
  //     setButtonLoader(false);
  //     // window.open(alreadyCreatedShippingLabel, "_blank");
  //     DownloadPdf();
  //   }
  // };
  const handleShippingLabel = () => {
    setButtonLoader(true);
    if (alreadyCreatedShippingLabel == null) {
      ExportApi.updateShippingLabelData(
        userId,
        orderId,
        "Shipped From Seller",
        // "Pending Inspection",
        "Shipped Out",
        "Shipped Out"
      )
        .then((resp) => {
          if (resp.data.message == "Label created successfully") {
            setOrderId(null)
            toast.success("Shipped From Seller Successfully");
            window.open(resp.data?.label_url, "_blank");
             DownloadPdf();
            setButtonLoader(false);
            handleClose();
            // window.open(resp.data.Data.postage_label.label_url, "_blank");
            
            if (localStorage.getItem("tokenuser")) {
              handlePendingData(JSON.parse(localStorage.getItem("tokenuser")).id);
              setButtonLoader(false);
            } else if (localStorage.getItem("admin")) {
              handlePendingData(JSON.parse(localStorage.getItem("admin")).id);
              setButtonLoader(false);
            } else {
           
              setButtonLoader(false);
            }
          } else {
             setOrderId(null)
            toast.error(resp.data.message);
            handleClose();
            setButtonLoader(false);
            if (localStorage.getItem("tokenuser")) {
              handlePendingData(JSON.parse(localStorage.getItem("tokenuser")).id);
            } else if (localStorage.getItem("admin")) {
              handlePendingData(JSON.parse(localStorage.getItem("admin")).id);
            } else {
              console.log("No Data Found");
            }
          }
        })
        .catch((err) => {
          console.log(err);
          setButtonLoader(false);
           setOrderId(null)
        });
    } else {
      setButtonLoader(false);
       window.open(alreadyCreatedShippingLabel, "_blank");
       DownloadPdf();
    }
  };


  const DownloadPdf = () => {
    const doc = new jsPDF("p", "pt", "a4");
    const tableContent = document.getElementById("werkk").innerHTML;
    doc.html(tableContent, {
      callback: () => {
        doc.save("Product.pdf");
      },
    });
  };
   
  const handlePendingData = (id) => {
    setUserId(id);
    ExportApi.getPendingData(id)
      .then((resp) => {
        let data = resp.data.data;
        let SellerPendingData = data?.sellerOrderlist?.filter(
          (item) =>
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Ready to Ship" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Shipped Out" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Failed to Ship" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Authentication Failed" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Item Returned" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Order Cancelled" ||
            item?.deliveryStatusId?.deliveryStatusForSeller?.status ==
            "Waiting on Seller"
        );
        setSellerCount(SellerPendingData?.length || 0);

        setData(SellerPendingData);

       
        setBuyOrder(data?.buyer);
        setSellerOrder(data?.sellerOrderlist);
        let BuyerPendingData = data?.buyerOrderlist?.filter(
          (item) =>
            item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Waiting on Seller" ||
            item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Pending Inspection" ||
            item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Shipped Out" ||
            // item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            // "Refunded" ||
            item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Payment Failed" ||
             item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Ready to Ship" ||
            item?.deliveryStatusId?.deliveryStatusForBuyer?.status ==
            "Placed With New Seller"

        );

        setBuyerCount(BuyerPendingData?.length || 0);
        setData2(BuyerPendingData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  const [handleShipStatusButtonColor, setHandleShipStatusButtonColor] = useState(false);
  const [unfilteredData, setUnfilteredData] = useState('');
  const [noDataBuyer, setNoDataBuyer] = useState('');
  const handleshipStatus = () => {
    if (!handleShipStatusButtonColor) {
      setUnfilteredData(Data);
      setNoDataBuyer(Data2);

      let filteredData = Data?.filter((item) => item.deliveryStatusId?.deliveryStatusForSeller
        ?.status == "Ready to Ship");
      setData(filteredData);
      setData2([]);
    } else {
      setData(unfilteredData);
      setData2(noDataBuyer);
    }
    // 👇️ toggle isActive state on click
    setHandleShipStatusButtonColor(current => !current);
  };

  // Mobile function event listener
  useEffect(() => {
    const handleMobileFunction = (e) => {
      const { action } = e.detail;
      if (action === 'readyToShip') {
        handleshipStatus();
      }
      if (action === 'printLabel') {
        handleShippingModal();
      }
      if (action === 'filter') {
        setShowFilterModel(true);
      }
    };
    
    window.addEventListener('mobileFunction', handleMobileFunction);
    return () => window.removeEventListener('mobileFunction', handleMobileFunction);
  }, [orderId]);

  // Desktop resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getPackageBuyerAddress = () => {
    ExportApi.getPackageData(loggedInUser?.id)
      .then((resp) => {
        let data = resp?.data?.data?.shipping_address;
        setBuyerAddress(data.street);
        setBuyerCity(data.city);
        setBuyerState(data.state);
        setBuyerZipCode(data.postal_code);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //get Filter Data
  // const GetData1 = () => {
  //   ExportApi.GetFilterData()
  //     .then((resp) => {
  //       let chipsetKeyArray = [];
  //       let conditionKeyArray = [];
  //       let brandKeyArray = [];
  //       let modalKeyArray = [];
  //       let seriesKeyArray = [];
  //       setres(resp?.data.data);
  //       resp?.data.data?.chipset?.map((val, i) => {
  //         let key = { [val]: false };
  //         chipsetKeyArray.push(key);
  //       });
  //       setchipsetKey([...chipsetKeyArray]);
  //       resp?.data.data?.condition?.map((val) => {
  //         if (val == 1) {
  //           let key = { ["New-Retail"]: false };
  //           conditionKeyArray.push(key);
  //         } else if (val == 2) {
  //           let key = { ["New-2nd Hand"]: false };
  //           conditionKeyArray.push(key);
  //         } else {
  //           let key = { ["Used"]: false };
  //           conditionKeyArray.push(key);
  //         }
  //       });
  //       setconditionKey([...conditionKeyArray]);
  //       resp?.data.data?.series?.map((val) => {
  //         let key = { [val]: false };
  //         seriesKeyArray.push(key);
  //       });
  //       setseriesKey([...seriesKeyArray]);
  //       resp?.data.data?.brands?.map((val) => {
  //         let key = { [val]: false };

  //         brandKeyArray.push(key);
  //       });
  //       setbrandKey([...brandKeyArray]);
  //       resp?.data.data?.model?.map((val) => {
  //         let key = { [val]: false };
  //         modalKeyArray.push(key);
  //       });
  //       setmodalKey([...modalKeyArray]);
  //       // setLoading(false);
  //       setFilterList(resp?.data?.data);
        
  //     })
  //     .catch((err) => console.log(err));
  // };

 

  window.addEventListener("Loginout", () => {
    localStorage.clear();
    navigate("/");
  });

  useEffect(() => {
    if (localStorage.getItem("tokenuser")) {
      handlePendingData(JSON.parse(localStorage.getItem("tokenuser")).id);
      handleSingleUserData(JSON.parse(localStorage.getItem("tokenuser")).id);
      // GetData1();
    } else if (localStorage.getItem("admin")) {
      handlePendingData(JSON.parse(localStorage.getItem("admin")).id);
      handleSingleUserData(JSON.parse(localStorage.getItem("admin")).id);
      // GetData1();
    } else {
      console.log("No Data Found");
    }
  }, []);
  const handleSingleUserData = (id) => {
 
    ExportApi.getSingleUserData(id)
      .then((resp) => {
        setLogineduser(resp.data.data._id)
       
        if (resp.data.message == "user not found") {
          window.dispatchEvent(new Event("Loginout"));
        } else {
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getPackageBuyerAddress();
  }, []);


  // Get all filters
  // useEffect(() => {
  //   axios.get('https://api.gpuwiz.com/product/filterallKey', {
  //     params: {
  //       Authorization: `Bearer ${token}`
  //     },
  //   })
  //     .then(function (response) {

  //       setFilterList(response.data.data);

  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // }, [])

  // clear All Filter
  const clearAllFilters = () => {
    setSelectStatusFilter([])
  };


  const hideModal = () => {
    setShowFilterModel(false);
  }

  const filteredOrderData = orderData?.filter((order) => {
    if (showBuyerData) {
    
      return (
        order?.deliveryStatusId?.deliveryStatusForBuyer?.status === selectStatusFilter
      );
    } else {
      return (
        order?.deliveryStatusId?.deliveryStatusForSeller?.status === selectStatusFilter
      );
    }
  });

  // Function to handle checkbox changes
  const handleCheckboxChange = (option) => {
 

    if (selectStatusFilter.includes(option)) {

      setSelectStatusFilter(selectStatusFilter.filter((item) => item !== option));

    } else {

      setSelectStatusFilter([...selectStatusFilter, option]);
    }
  };

  // Function to filter data based on selected filters
  const filterData = (data, filters, showBuyerData) => {
   
    return data?.filter((order) => {
      const status = showBuyerData
        ? order?.deliveryStatusId?.deliveryStatusForBuyer?.status
        : order?.deliveryStatusId?.deliveryStatusForSeller?.status;
      return filters.length === 0 || filters.includes(status);
    });
  };

 

  // Function to handle removing a filter
  const handleRemoveFilter = (filterValue) => {
    const updatedFilters = selectStatusFilter.filter(
      (filter) => filter !== filterValue
    );
    setSelectStatusFilter(updatedFilters);
  };

  // const handleCheck = (data, id, orderid) => {
  //   console.log(data,id,orderid,"orderid>>>>321");
  //   // return
  //   if (data) {
  //     setOrderId(orderid);
 
  //     let product_id = orderid;
  //     let result = Data.filter((item) => item?._id == product_id);
  //     console.log(Data,"Data>>123");
  //     console.log(result,"13445555555555555");
  //     setSelectData(result[0].productId?._id);
  //   } else {
  //     setSelectData();
  //     setOrderId();
  //   }
  // };
const handleCheck = (data,  orderid , item) => {

  if (data) {
    setOrderId(orderid);
    setOrder(item);
    const orderDate = new Date(item?.createdAt);
    orderDate.setDate(orderDate.getDate() + 3);
    setShipByDate(orderDate);
  } else {
    // setSelectData();
    setOrderId(null);
    setShipByDate(null);
    setOrder(null)
  }
};

 

  const spacedModel = nmodel ? nmodel.replace(/:/g, ' :').replace(/-/g, ' -') : '';
  const spacedbuyerSku = buyerSku ? buyerSku.replace(/:/g, ' :').replace(/-/g, ' -') : '';
  const spacedDate = nmodel ? nmodel.replace(/:/g, ' :').replace(/-/g, ' -') : '';
  const handleSelect = (orderId) => {
    setSelectedOrderId(orderId);
  };
  return (
    <div>
      <div id="werkk" 
      style={{ display: "none" }}
      >
        <div className="pdf-content" style={{fontFamily:" sans-serif"}}>
          <div className="pdf-header">
            {/* <span>GPUWIZ</span> */}
            <img src={`data:image/png;base64,${logo_image}`}
               style={{ height: '42px', width: '150px' }} 
               alt="Logo" 
              />
          </div>
          <hr />
          <div className="center-text m-30">
            <h2>Ship by {moment(shipeByDate).format("MM/DD/YYYY")}</h2>
          </div>
          <hr />
          <div className="center-text m-30 order-condition">
            <h2>Order:&nbsp;{norderid}</h2>
            <p className="pname">
              {order?.productId?.productname}
            </p>
            <span>
              Condition:{" "}
              {order?.productId?.type == 1 || order?.productId?.type == 2
                ? "New"
                : order?.productId?.type == 3
                  ? "Used"
                  : "Used"}
            </span>

            {(order?.productId?.sku &&
              order?.productId?.sku?.trim() !== "") ? (
              <span className="pname">
                MPN&nbsp;: {order?.productId?.sku}
              </span>
            ) : (order?.productId?.upc &&
              order?.productId?.upc?.trim() !== "") ? (
              <span className="pname">
                UPC&nbsp;: {order?.productId?.upc}
              </span>
            ) : null
            }

          </div>
          <hr />
          <div className="m-30 shipping-instruction">
            <h4>Shipping Instructions:</h4>
            <ul style={{ listStyleType: 'decimal' }}>
              <li className="number">
                We love fast shippers. If you can, ship within 24 hours (you’ve got up to 72). Fast shippers may unlock future discounts/perks.
              </li>
              <li className="number">
                Label: Use the GPUwiz prepaid label as-is. Match the carrier on the label (UPS or FedEx).
                Box size: {"<= 18×12×8 in"}. If it truly won’t fit, email <span><a href="mailto:support@gpuwiz.com">support@gpuwiz.com</a></span> before shipping.
              </li>
              <li>
                Package &nbsp;your GPU
                <ul style={{ listStyleType: 'disc' }}>
                  <li>
                    If shipping without a retail box:
                    <ul style={{ listStyleType: 'disc' }}>
                      <li>
                        Anti-static bag is recommended, not required. If you don’t have one: clean sleeve + bubble wrap works.
                        Wrap the GPU in bubble wrap so every surface is covered (~1" thick).
                        Tape the wrap so it can’t unwind. Put in a box that fits snugly; add padding so it cannot move.
                      </li>
                    </ul>
                  </li>
                  <li>
                    If shipping with a retail box:
                    <ul>
                      <li style={{ listStyleType: 'disc' }}>Place the retail box inside a larger shipping box with padding on all sides so it cannot move.</li>
                    </ul>
                  </li>
                  <li>
                    Put any adapters/cables in a small inner bag so they don’t scratch the card.
                  </li>
                  <li>
                    Place this packing slip inside the outer box.
                  </li>

                </ul>
              </li>
              <li>
                Seal & ship
                <ul style={{ listStyleType: 'disc' }}>
                  <li>
                    Seal using the H-tape method (shipping tape only). Remove/cover old labels.
                  </li>
                  <li>
                    Drop off or schedule a pickup with the same carrier as the label. Keep the receipt/scan.
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              Important: We’re not responsible for items packed inadequately. Shipments damaged from poor packing may fail intake and fees may apply (see Seller Fees & Standards).
              Full guide: <a href={`${process.env.REACT_APP_REDIRECT_URI}/help/Shipping-Instructions`}>{`${process.env.REACT_APP_REDIRECT_URI}/help/Shipping-Instructions`}</a>.
            </p>
          </div>
        </div>
      </div>

      <Row>
        <Col lg={12} className="mt-sm-5 mt-2 mx-1">
          {/* Desktop Function Buttons - Show only on desktop */}
          {isDesktop && (
            <div className="desktop-function-buttons">
              <Button
                className={`${handleShipStatusButtonColor ? 'bg-success' : 'bg-white'} ${handleShipStatusButtonColor ? 'text-white' : 'text-black'} border border-2`}
                onClick={handleshipStatus}
              >
                Ready to ship
              </Button>
              {
                !showBuyerData && (
                  <Button
                    className="bg-white text-black border border-2"
                    onClick={handleShippingModal}
                  >
                    Print shipping label
                  </Button>
                )
              }
              <Button
                className="bg-white text-black border border-2"
                onClick={() => setShowFilterModel(true)}
              >
                Filter
              </Button>
            </div>
          )}
        </Col>
        <Col
          lg={12}
          className="product_list_table table-responsive mt-sm-5 mt-2"
        >
          <>
            
            {selectStatusFilter?.length > 0 && 
              <div className="text-center text-sm-start d-flex">
                <Button
                  className="rounded-0 bg-white border text-dark px-5 py-2 fw-bold"
                  onClick={() => clearAllFilters()}
                >
                  Clear all filters
                </Button>

                {selectStatusFilter?.length > 0 && (
                  <div className="filters-list d-flex align-items-center">
                    {selectStatusFilter?.map((button, i) => {
                      return (
                        <div className="filter-button" key={i}>
                          <span className="bg-custom-light border px-3 py-2 text-center ms-2 fw-500 fs-6 mb-0 d-flex align-items-center">
                            {button}
                            <button
                              type="button"
                              className="bg-transparent border-0 py-0 text-dark btn btn-primary pe-0 mb-0"
                              onClick={() => handleRemoveFilter(button)}
                            >
                              X
                            </button>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              }

            {/* <div className="data-list d-flex mt-4">

              <button className={`btn border me-3 ${showBuyerData ? 'active' : ''}`} onClick={() => setShowBuyerData(true)}>Buyer Data</button>
              {!localStorage.getItem("admin") ?
                <button className={`btn border ${showBuyerData ? '' : 'active'}`} onClick={() => setShowBuyerData(false)}>Seller Data</button>
                : ""}
            </div> */}

             <div className="data-list d-flex mt-4 p-3">

            <button className={`btn border me-3 position-relative ${showBuyerData ? 'active' : ''}`} onClick={() => setShowBuyerData(true)}>
              Buyer Data
              <span className="count-badge">{buyercount}</span>
            </button>

            {!localStorage.getItem("admin") && (
              <button className={`btn border position-relative ${showBuyerData ? '' : 'active'}`} onClick={() => setShowBuyerData(false)}>
                Seller Data
                <span className="count-badge">{sellercount}</span>
              </button>
            )}
          </div>


            <Table
              bordered
              striped
              className="align-middle text-center managment-table"
            >
              <thead>
                <tr>
                  <th className="text-start"
                      style={!isDesktop ? { minWidth: 0, } : null}
                  ></th>
                  <th ></th>
                  <th onClick={() => sortHere("productId.chipset")}>
                    Chipset
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>

                  <th onClick={() => sortHere("productId.brand")}>
                    Brand
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                  <th onClick={() => sortHere("productId.series")}>
                    Series{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                  <th onClick={() => sortHere("productId.model")}>
                    Model{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>

                  <th onClick={() => sortHere("_id")}>
                    Order No.{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                  <th onClick={() => sortHere("bidId.subTotal")}>
                    Status{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                  <th onClick={() => sortHere("createdAt")}>
                    Order Date{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                  <th onClick={() => sortHere("bidId.subTotal")}>
                    Price{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      />
                    </svg>
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataToDisplay?.length > 0 ? (

                  (selectStatusFilter.length > 0 ? filterData(dataToDisplay, selectStatusFilter, showBuyerData) :   filterData(dataToDisplay, selectStatusFilter, showBuyerData))?.map((item, index) => {

                    return (
                      item?.buyerId?._id == logineduser ||
                        item?.sellerId?._id || item?.oldsellerId?._id  == logineduser && item?.deliveryStatusId?.deliveryStatusForSeller?.status != "Order Cancelled" && item?.deliveryStatusId?.deliveryStatusForSeller?.status != "Failed to Ship" && item?.deliveryStatusId?.deliveryStatusForSeller?.status != "Authentication Failed" ?
                        <tr key={index}>
                          <td 
                              style={!isDesktop ? { minWidth: 0, } : null}
                              >
                          </td>
                          <td>
                            <div className="d-flex align-items-end position-relative">

                              {dataToDisplayText == "Data" ? (
                                <Form.Check
                                  className="d-inline"
                                  type="checkbox"
                                  checked={orderId && orderId == item._id}
                                   disabled={
                                  [
                                    "Order Cancelled",
                                    "Authentication Failed",
                                    "Waiting on Seller",
                                    "Failed to Ship",
                                    "Refunded"
                                  ].includes(item?.deliveryStatusId?.deliveryStatusForSeller?.status) 
                                  ||
                                  [
                                    "Order Cancelled",
                                    "Authentication Failed",
                                    "Waiting on Seller",
                                    "Failed to Ship",
                                    "Refunded"
                                  ].includes(item?.deliveryStatusId?.deliveryStatusForOldSeller?.status)
                                  ||
                            ["2", "3"].includes(item?.deliveryStatusId?.last_cancel_type)
                                }
                                  onChange={(e) =>
                                    handleCheck(
                                      e.target.checked,
                                      item._id, 
                                      item
                                    )
                                  }
                                />
                              ) : (
                                <> 
                                  
                          </>
                              )}

                              <img
                                src={`${item.productId?.image[0]}`}
                                style={{ width: "70px" }}
                                onClick={() =>
                                  navigate(`/product/${item.productId.slug}`)
                                }
                              />
                              <div className="position-relative ms-1" style={{ cursor: "default" }}>
                                <span className="d-block text-center">
                                  {

                                    item.productId?.type == 2
                                      ? "New"
                                      : "Used"}
                                </span>

                                {descriptionindex == index ? (
                                  <span
                                    className="bg-none border-0"
                                    onClick={() => setdescriptionindex()}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="#0000ff"
                                      className="bi bi-chevron-down"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        filerule="evenodd"
                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                      />
                                    </svg>
                                  </span>
                                ) : (
                                  <span
                                    className="bg-none border-0"
                                    onClick={(e) => { setdescriptionindex(index) }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="#0000ff"
                                      className="bi bi-chevron-down"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        filerule="evenodd"
                                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                      />
                                    </svg>
                                  </span>
                                )}
                                <OutsideClickHandler
                                  onOutsideClick={(e) => {
                                    if (!e.target.closest('.modal_custom_')) {
                                      setdescriptionindex();
                                      setProductId();
                                      setProductStatus();
                                    }
                                  }}
                                ></OutsideClickHandler>

                                {descriptionindex == index ? (
                                  <div className="modal_custom_ pending-mod" style={{
                                    top: `45px`,
                                    left: `10px`,
                                  }}>
                                    <div className="inner_customModal_one">
                                      <h6
                                        dangerouslySetInnerHTML={{
                                          __html: `${item?.productId?.description ? item?.productId?.description.substring(0, 351) : "No product description"}${item?.productId?.description?.length > 351 ? '...' : ''}`,
                                        }}
                                      ></h6>
                                      {item?.productId?.description?.length > 351 ?
                                        <a onClick={() =>
                                          navigate(`/product/${item.productId.slug}`)
                                        }>See more</a> : ""}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div style={{ cursor: "default" }} title={item.productId?.chipset} >
                              {item.productId?.chipset}
                            </div>
                          </td>
                          <td>
                            <div style={{ cursor: "default" }} title={item.productId?.brand} >
                              {item.productId?.brand}
                            </div>
                          </td>
                          <td>
                            <div style={{ cursor: "default" }} title={item.productId?.series} >
                              {item.productId?.series}
                            </div>
                          </td>
                          <td>
                            <div className="usermodel" title={item.productId?.model}>
                              {item.productId?.model}
                            </div>
                          </td>
                          {/* {item._id} */}
                          <td>
                            <div style={{ cursor: "default" }} title={item?.orderId} >
                              {item?.orderId}

                              {productId == index ? (
                                <Button
                                  className="bg-none border-0"
                                  onClick={() => setProductId()}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#0000ff"
                                    className="bi bi-chevron-down"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      filerule="evenodd"
                                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="bg-none border-0"
                                  onClick={() => setProductId(index)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#0000ff"
                                    className="bi bi-chevron-down"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      filerule="evenodd"
                                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </Button>
                              )}
                              {productId == index ? (
                                <div className="modal_custom_selling_price"> 
                                <div  >
                                  <div className="inner_customModal_two" style={{ padding: '10px' }}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: `<div class="order-detail-list">
                                    <div class='d-flex justify-content-between'>
                                        <p class="me-3">Sale Price</p>
                                        <p>$${dataToDisplayText == "Data2" ? (
                                            item?.bidId?.bidAmount
                                          ) :
                                            (item?.askId?.askAmount ?? item?.directSellId?.askAmount)
                                          }</p>
                                    </div>
                                    ${dataToDisplayText == "Data" ? (
                                            `<div class='d-flex justify-content-between'>
                                            <p class="me-3">Transaction Fee</p>
                                            <p>$${item?.askId?.transactionFee ?? item?.directSellId?.transactionFee}</p>
                                        </div>` 
                                          ) : ""}
                                    <div class='d-flex justify-content-between'>
                                        <p class="me-3">${dataToDisplayText == "Data2" ? "Processing Fee" : "Payment Processing Fee"}</p>
                                        <p>$${dataToDisplayText == "Data2" ? (
                                            item?.bidId?.processingFee
                                          ) :
                                            (item?.askId?.processingFee ?? item?.directSellId?.processingFee)
                                          }</p>
                                    </div>
                                    <div class='d-flex justify-content-between'>
                                        <p class="me-3">Shipping</p>
                                        <p>$${dataToDisplayText == "Data2" ? (
                                            item?.bidId?.shippingFee
                                          ) :
                                            (item?.askId?.shippingFee ?? item?.directSellId?.shippingFee)
                                          }
                                        </p>
                                    </div>

                                   ${dataToDisplayText == "Data2" &&
                                            item?.bidId?.returnShield === true &&
                                            item?.bidId?.returnShieldFee > 0
                                            ? `
  <div class='d-flex justify-content-between'>
      <p class="me-3">Return Shield Fee (8%)</p>
      <p>$${item?.bidId?.returnShieldFee}</p>
  </div>
  `
                                            : ""
                                          }
                                    ${dataToDisplayText == "Data2" ? (
                                            `<div class='d-flex justify-content-between'>
                                          <p class="me-3">Sales Tax</p>
                                          <p>$${item?.bidId?.salesTax}</p>
                                      </div>`
                                          ) : ""}


                                    <div class='d-flex justify-content-between fw-bold'>
                                        <p class="me-3">TOTAL</p>
                                        <div class="d-flex align-items-center">
                                        <p class="mb-0 me-1">$${dataToDisplayText == "Data2" ? (
                                            item?.bidId?.subTotal
                                          )
                                            :
                                            (item?.askId?.subTotal ?? item?.directSellId?.subTotal)
                                          }
                                      </p>
                                    ${item?.payment_details?.status == "Paid" ?
                                            // If payment status is "paid"
                                            `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#008000" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                      </svg>`
                                            : item?.payment_details?.status == "failed" ?
                                              // If payment status is "failed"
                                              `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FF0000" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                        </svg>`:
                                              // If payment status is neither "paid" nor "failed"
                                              `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 5L3 10L8 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M3 10H11C16.523 10 21 14.477 21 20V21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>`
                                          }
                                    </div>
                                    </div>
                                </div>
                                ${dataToDisplayText == "Data" ? (
                                            `<div class='d-flex justify-content-between'>
                                      <p class="me-3">Inspection Result</p>
                                      <p>${item?.deliveryStatusId.authStatus?.status}</p> &nbsp;
                                        ${item?.deliveryStatusId.authStatus?.status === "fail" ?
                                              item?.deliveryStatusId?.authStatus?.reason.length > 0 && item?.deliveryStatusId?.authStatus?.reason.map((reason, index) => (
                                                ` <p key={index}>${reason}test</p>`
                                              )
                                              ) : ""}
                                  </div>
                                  <div class='d-flex justify-content-between'>
                                      <p class="me-3">${item?.deliveryStatusId.authStatus?.comment ? "Comment" : ""}</p>                             
                                      <p>${item?.deliveryStatusId.authStatus?.comment ? item?.deliveryStatusId.authStatus?.comment : ""}</p>
                                  </div>`
                                          ) : ""}`

                                      }}></div>
                                  </div>
                                </div>
                                </div>
                              ) : null}
                            </div>
                          </td>

                          <td>
                            {
                              dataToDisplayText == "Data2" ? (
                                // item?.buyerId?._id != logineduser ? (
                                //   <Button style={{cursor:'not-allowed'}} className="order_status_newseller border text-white">
                                //      Placed With New Seller
                                //   </Button>) :
                                item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Waiting on Seller" ? (
                                  <Button className="order_status_waiting border text-white">
                                    {
                                      item?.deliveryStatusId.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Ready to Ship" ? (
                                  <Button  className="order_status_ready_shipment border text-white">
                                    {
                                      item?.deliveryStatusId.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Payment Failed" ? (
                                  <Button className="order_status_shipped_seller border text-white">
                                    {
                                      item?.deliveryStatusId.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Pending Inspection" ? (
                                  <Button className="order_status_ready_test border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Ready For Shipment" ? (
                                  <Button className="order_status_ready_shipment border text-white">
                                    {item?.deliveryStatusId?.deliveryStatus?.status}
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Shipped Out" ? (
                                  <Button className="order_status_shipped_out border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Delivered" ? (
                                  <Button className="order_status_recently_delivered border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Placed With New Seller" ? (
                                  <Button className="order_status_newseller border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Refunded" ? (
                                  <Button className="order_status_refunded border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForBuyer
                                  ?.status == "Order Cancelled" ? (
                                  <Button className="order_status_return border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForBuyer
                                        ?.status
                                    }
                                  </Button>
                                ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Failed to Ship" ? (
                                  <Button className="order_status_failed border text-white">
                                    {
                                      item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                    }
                                  </Button>
                                ) :
                                  item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Order Cancelled" ? (
                                    <Button className="order_status_refunded border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : (
                                    ""
                                  )
                              ) :
                                (

                                  item?.sellerId?._id != logineduser ? (
                                    item?.deliveryStatusId?.last_cancel_type == "2" ? (
                                      <Button style={{ cursor: 'not-allowed' }} className="order_status_failed_to_ship border text-white">
                                        Failed to Ship
                                      </Button>
                                    ) : item?.deliveryStatusId?.last_cancel_type == "3" ? (
                                      <Button style={{ cursor: 'not-allowed' }} className="order_status_failed_to_ship border text-white">
                                        Authentication Failed
                                      </Button>
                                    ) : (
                                      <Button style={{ cursor: 'not-allowed' }} className="order_status_refunded border text-white">
                                        Order Cancelled
                                      </Button>
                                    )
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Waiting on Seller" ? (
                                    <Button className="order_status_waiting border text-white">
                                      {
                                        item?.deliveryStatusId.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Payment Failed" ? (
                                    <Button className="order_status_shipped_seller border text-white">
                                      {
                                        item?.deliveryStatusId.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Pending Inspection" ? (
                                    <Button className="order_status_ready_test border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Ready to Ship" ? (
                                    <Button className="order_status_ready_shipment border text-white">
                                      {item?.deliveryStatusId?.deliveryStatusForSeller?.status}
                                    </Button>
                                  ) :item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Waiting on Seller" ? (
                                    <Button className="order_status_ready_shipment border text-white">
                                      {item?.deliveryStatusId?.deliveryStatusForSeller?.status}
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Shipped Out" ? (
                                    <Button className="order_status_shipped_out border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Delivered" ? (
                                    <Button className="order_status_recently_delivered border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Placed With New Seller" ? (
                                    <Button className="order_status_return border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Refunded" ? (
                                    <Button className="order_status_return border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Order Cancelled" ? (
                                    <Button className="order_status_cancelled border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  ) : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Authentication Failed" ? (
                                    <Button className="order_status_failed_to_ship border text-white">
                                      {
                                        item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                      }
                                    </Button>
                                  )
                                    : item?.deliveryStatusId?.deliveryStatusForSeller?.status == "Failed to Ship" ? (
                                      <Button className="order_status_failed_to_ship border text-white">
                                        {
                                          item?.deliveryStatusId?.deliveryStatusForSeller?.status
                                        }
                                      </Button>
                                    ) : ''
                                )
                            }
                            <span className="position-relative ms-2"> 
                            {productStatus == index ? (
                              <span
                                className=""
                                onClick={() => { setProductStatus(); showPostionTooltip() }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#0000ff"
                                  className="bi bi-chevron-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    filerule="evenodd"
                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                  />
                                </svg>
                              </span>
                            ) : (
                              <span
                                className=""
                                onClick={() => setProductStatus(index)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#0000ff"
                                  className="bi bi-chevron-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    filerule="evenodd"
                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                  />
                                </svg>
                              </span>
                            )}
                            {productStatus == index ? (
                              <div className="modal_custom_ pending-mod right-tooltip top-0 left-30"  
                              >
                                <div className="inner_customModal_one">
                                  <h6
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        item?.sellerId?._id === logineduser || item?.buyerId?._id === logineduser
                                          ? (dataToDisplayText === "Data2"
                                            ? item?.deliveryStatusId?.deliveryStatusForBuyer?.status || "No description available"
                                            : item?.deliveryStatusId?.deliveryStatusForSeller?.status || "No description available")
                                          : (item?.deliveryStatusId?.last_cancel_type === "2"
                                            ? 'Failed to Ship'
                                            : item?.deliveryStatusId?.last_cancel_type === "3"
                                              ? 'Authentication Failed'
                                              : 'Order Cancelled'
                                          )
                                    }}
                                  ></h6>


                                </div>
                              </div>
                            ) : null}
                            </span>
                          </td>

                          <td>
                            <div style={{ cursor: "default" }} title={moment(item?.createdAt).format("l")} >
                              {moment(item?.createdAt).format("l")}
                            </div>
                          </td>
        
                          <td>
                          {dataToDisplayText == "Data2" ? (
                            <div style={{ cursor: "default" }} title={`$${Number(item?.bidId?.subTotal || 0).toFixed(2)}`}>
                                {`$${Number(item?.bidId?.subTotal || 0).toFixed(2)}`}
                            </div>
                          ) : logineduser == item?.olderaskId?.userId ? (
                            <div style={{ cursor: "default" }} title={`$${Number(item?.olderaskId?.subTotal || 0).toFixed(2)}`}>
                                 {`$${Number(item?.olderaskId?.subTotal || 0).toFixed(2)}`}
                            </div>
                          ) : (
                           
                        <div
                              style={{ cursor: "default" }}
                              title={`$${Number((item?.askId?.subTotal ?? item?.directSellId?.subTotal) || 0).toFixed(2)}`}
                            >
                              {`$${Number((item?.askId?.subTotal ?? item?.directSellId?.subTotal) || 0).toFixed(2)}`}
                            </div>

                          )}
                        </td>

                        </tr> : ""
                    )
                  })
                ) : (
                  <span>{showBuyerData ? 'No Buyer Data Found' : 'No Seller Data Found'}</span>
                )}
              </tbody>
            </Table>
          </>
        </Col>
      </Row>

      {/* start print label */}
      <Modal show={show} onHide={handleClose} backdrop={true}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="my-3 ">
              Ship From
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">

          {alreadyCreatedShippingLabel == null ?
            <Form>
              <div className="px-2">
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Name"
                    // value={buyerName}
                    value={sellerName}
                  // onChange={(e) => setSellerName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Address"
                    // value={buyerAddress}
                    value={sellerAddress}
                  // onChange={(e) => setSellerAddress(e.target.value)}
                  />
                </Form.Group>
                <div className="d-sm-flex justify-content-start gap-2">
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="fs-6 fw-bold mb-0">City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your City"
                      // value={buyerCity}
                      value={sellerCity}
                    // onChange={(e) => setSellerCity(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="fs-6 fw-bold mb-0 ">State</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your State"
                      // value={buyerState}
                      value={sellerState}
                    // onChange={(e) => setSellerState(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label
                      className="fs-6 fw-bold mb-0
                      "
                    >
                      Zip Code
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your Zip Code"
                      // value={buyerZipCode}
                      value={sellerZipCode}
                    // onChange={(e) => setSellerZipCode(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Phone</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Your Phone No."
                    // value={buyerPhone}
                    value={sellerPhone}
                  // onChange={(e) => setSellerPhone(e.target.value)}
                  />
                </Form.Group>
              </div>
              <h5 className="my-3 ">
                Ship To
              </h5>
              <div className="px-2">
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Name"
                    // value={sellerName}
                    value={buyerName}
                  // onChange={(e) => setBuyerName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Your Address"
                    // value={sellerAddress}
                    value={buyerAddress}
                  // onChange={(e) => setBuyerAddress(e.target.value)}
                  />
                </Form.Group>
                <div className="d-sm-flex justify-content-between gap-2">
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="fs-6 fw-bold mb-0">City</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your City"
                      // value={sellerAddress}
                      value={buyerCity}
                    // onChange={(e) => setBuyerCity(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="fs-6 fw-bold mb-0">State</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your State"
                      // value={sellerState}
                      value={buyerState}
                    // onChange={(e) => setBuyerState(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-2 d-flex align-items-center gap-2"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="fs-6 fw-bold mb-0">
                      Zip Code
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Your Zip Code"
                      // value={sellerZipCode}
                      value={buyerZipCode}
                    // onChange={(e) => setBuyerZipCode(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <Form.Group
                  className="mb-2 d-flex align-items-center gap-2"
                  controlId="formBasicEmail"
                >
                  <Form.Label className="fs-6 fw-bold mb-0">Phone</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Your Phone"
                    // value={sellerPhone}
                    value={buyerPhone}
                  // onChange={(e) => setBuyerPhone(e.target.value)}
                  />
                </Form.Group>
              </div>
            </Form>
            :
            <h3>Shipping Label Already Created !!!</h3>}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            className="d-block w-100"
            onClick={handleShippingLabel}
            disabled={buttonLoader}
          >
            {buttonLoader ? "Please wait..." : "Print Label"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/*end print label */}

      {/* start Filter Model */}
      <Modal
        show={showFilterModel}
        onHide={hideModal}
        backdrop={true}

      >
        <Modal.Header closeButton>
          <Modal.Title>Product Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">

          <div className="mt-sm-5 mt-3 mb-sm-5">
            {statusOptions.map((option, index) => (
              <div className="mb-2" key={index}>
                <input
                  type="checkbox"
                  value={option}
                  checked={selectStatusFilter.includes(option)}
                  onChange={() => handleCheckboxChange(option)}
                  className='form-check-input'
                />
                <label key={option} className='form-check-label ms-2 mb-0'>{option}</label>
              </div>

            ))}
          </div>
        </Modal.Body>
      </Modal>
      {/* End Filter Model */}
    </div>
  );
};

export default PendingTable;